<template>
  <v-dialog v-model="$store.state.upgradeDialog" max-width="420" width="90%">
    <v-card class="rounded-xl pa-4 text-center elevation-6" outlined>
      <!-- Icon Header -->
      <div class="mt-3 mb-2">
        <v-avatar color="amber lighten-4" size="64">
          <v-icon large color="amber darken-3">mdi-lock-outline</v-icon>
        </v-avatar>
      </div>

      <!-- Title -->
      <v-card-title class="justify-center text-h6 font-weight-bold px-2 pt-0">
        {{ itemTitle }} is a Paid Module
      </v-card-title>

      <!-- Subtitle -->
      <v-card-subtitle
        class="text-subtitle-2 grey--text text--darken-1 px-4 mb-3"
      >
        Upgrade your plan to <strong>Essential</strong> or
        <strong>Premium</strong> to unlock full access to this feature.
      </v-card-subtitle>

      <!-- WhatsApp Call-to-Action Box -->
      <v-card class="mx-4 mb-4 pa-3 rounded-lg green lighten-5" flat outlined>
        <div class="d-flex align-center justify-center mb-1">
          <v-icon small color="green darken-2" class="mr-1"
            >mdi-whatsapp</v-icon
          >
          <span class="font-weight-bold green--text text--darken-3 text-caption"
            >Instant Upgrade</span
          >
        </div>
        <p class="text-body-2 mb-0 grey--text text--darken-3">
          WhatsApp us at
          <a
            href="https://wa.me/27814826615"
            target="_blank"
            class="green--text text--darken-4 font-weight-bold text-decoration-none"
          >
            081 482 6615
          </a>
          to upgrade your account in minutes.
        </p>
      </v-card>

      <!-- Actions -->
      <v-card-actions class="justify-center pb-2">
        <v-btn
          color="grey darken-1"
          text
          rounded
          class="px-6 font-weight-medium"
          @click="closeDialog()"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    itemTitle: {
      type: String,
      default: "This Item",
    },
  },
  methods: {
    closeDialog() {
      this.$store.commit("setUpgradeDialog", false);
    },
  },
};
</script>
